import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-pay-check-batches',
  templateUrl: './pay-check-batches.component.html',
  styleUrls: ['./pay-check-batches.component.css']
})
export class PayCheckBatchesComponent implements OnInit {
    public setting?: Setting;

    public itemsListPayCheckBatches: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(3493))[0];
    }

    private async loadPayCheckBatches(): Promise<void> {
        this.itemsListPayCheckBatches = await this.datatask.Post(1367);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'paycheckbatch':
                this.stateService?.go('paycheckbatch', { paycheckbatch_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadSetting();
        this.loadPayCheckBatches();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    show_setting: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('payCheckBatches', {
//        templateUrl: 'views/components/views/payCheckBatches/payCheckBatches.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'payCheckBatchesService', function (stateService, payCheckBatchesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                setting: {},
//                itemsListPayCheckBatches: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await payCheckBatchesService.getSetting())[0];
//            }

//            async function loadPayCheckBatches() {
//                vm.model.itemsListPayCheckBatches = await payCheckBatchesService.listPayCheckBatches();
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'paycheckbatch':
//                        go({ paycheckbatch_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//                loadPayCheckBatches();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
